<template>
	<div class="SavePanelView" :class="[saving && 'edit']">
		<button class="SavePanelViewSave" @click.prevent="$emit('save')">
			Save changes
		</button>
	</div>
</template>

<script>
export default {
	name: "SavePanelView",
	props: {
		dirty: { type: Boolean, default: true },
		prompt_cancel: { type: Boolean, default: true },
		saving: { type: Boolean, default: false },
	},
	data() {
		return {
			saved: false,
		};
	},
	watch: {
		saving(n, o) {
			if (n === false && this.show === false) {
				this.saved = true;
			}
		},
	},
};
</script>

<style scoped lang="less">
@import "~styles/const.less";
@import "~styles/styles.less";

@r: .SavePanelView;

@{r} {
	width: 100%;
	display: flex;
	font-family: @Graphik-LCG;

	&Save {
		height: 40px;
		width: 100%;
		pointer-events: none;
		font-size: 12px;
		line-height: 14px;
		text-align: center;
		letter-spacing: -0.02em;
		background-color: @color-border-login;
		color: @color-border-gray3;
		transition: opacity 0.3s ease, background-color 0.3s ease,
			color 0.3s ease;
	}

	&.edit {
		@{r}Save {
			background-color: @color-black;
			color: @color-white;
			pointer-events: auto;
			cursor: pointer;
			opacity: 1;

			&:hover {
				opacity: 0.7;
			}
		}
	}
}
</style>
